import axios from 'axios';
import { BASE_URL} from '../config';
import axiosApiInstance from "../../interceptors/axiosApiInstance";

const AuthService = {
    login: async function (params) {
        try {
            const response = await axios.post(await BASE_URL + `/auth/login`, params);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    verifyResetPassword: async function (params) {
        try {
            const response = await axios.post(await BASE_URL + `/auth/verify-reset-password`, {
                hashCode: params
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    forgetPassword: async function (email) {
        try {
            const response = await axios.post(await BASE_URL + `/auth/forgot-password`, {
                user_email: email,
                d: {
                    p: window.location.protocol,
                    h: window.location.host
                }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    resetPassword: async function (params) {
        try {
            const response = await axios.post(await BASE_URL + `/auth/reset-password`, {
                newPassword: params.newPassword,
                newPasswordRetry: params.confirmPassword,
                user_id: params.userId,
                hashCode: params.hashCode
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    oAuthGenerate: async function (params) {
        try {
            const response = await axiosApiInstance.post(await BASE_URL + `/auth/token/oauth`, params);
           // const response = await axios.post(await BASE_URL + `/auth/token/oauth`, params);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
};

export default AuthService;
